/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';

import Frame from '../frame';
import Style from './style';
import { filtersConfig } from './helper';
import { actions } from '../../../../../../../store/reducers/dashboard';
import { connect } from 'react-redux';
import RecTable from '../recTable';

export const filterEvent = (ev = {}, loc) => {
  const e = {
    ...ev,
    id: ev.datastakeId,
    title: ev.eventTitle,
    location: loc,
  };
  return e;
}

export const getMeasureStatus = (d = {}) => {
  if (typeof d.completedAt === 'string') {
    return 'completed';
  }
  if (Array.isArray(d.events)) {
    return 'inProgress';
  }
  return 'proposed';
};

const emptyObj = {};

const Recommendations = ({
  t = (t) => t,
  data = null,
  PmeDashboardGetWithFilters,
  language,
  isOwnData = false,
  selectedProject,
  organisationName = null,
  sourceId = null,
  allEvents = [],
  canFetch = false,
  user,
}) => {
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [initialFetchIsDone, setInitialFetchIsDone] = useState(false);
  const [frameActions, setFrameActions] = useState(null);
  const [initLoaded, setInitLoaded] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});

  const dataSource = useMemo(() => {
    if (data) {
      setInitialFetchIsDone(true);
      setTotal(data.metadata ? data.metadata.total : 0);
      return (data.records || []).map((d, i) => {
        const riskCategory = (data.options.riskCategory || []).find(opt =>
          opt.value === d.riskCategoryCamelCase
        );
        const riskType = (data.options.riskType || []).find(opt =>
          opt.value === d.riskTypeCamelCase
        );
        const responsibility = (d.linkedStakeholder || {}).name;

        return {
          key: i,
          ...d,
          riskType: riskType ? riskType.label : '-',
          riskCategory: riskCategory ? riskCategory.label : '-',
          responsibility,
          events: (d.events || []).map((e) => filterEvent(allEvents.find((ev) => ev.datastakeId === e), d.area)),
          status: getMeasureStatus(d),
        }
      });
    } else if (total || initialFetchIsDone) {
      setTotal(0);
      setInitialFetchIsDone(false);
    }
    return [];
  }, [data, allEvents]);

  const setLoading = (val) => frameActions.loading(val);

  useEffect(() => {
    if (frameActions) {
      frameActions.loading(!initialFetchIsDone);
    }
  }, [frameActions, initialFetchIsDone]);

  const getFilters = () => {
    if (data) {
      const settings = {};
      Object.entries(filtersConfig.settings).forEach(([k, v]) => {
        const opts = data.options[k] || data.options[v.optionsName];
        if (opts) {
          settings[k] = {
            ...v,
            options: opts,
          };
        } else {
          settings[k] = {
            ...v,
          };
        }
      });
      return {
        type: filtersConfig.type,
        settings,
      };
    }
    return filtersConfig;
  };

  const filters = getFilters();

  useEffect(() => {
    if (canFetch) {
      if (frameActions && frameActions.resetFilters) {
        frameActions.resetFilters();
        frameActions.setClearFiltersVisibility(false);
      }
      setPage(1);
      if (initLoaded) {
        PmeDashboardGetWithFilters({
          noReset: true,
          widget: 'recommendations',
          setLoading,
          filters: {},
          pagination: {
            page: 1,
            perPage: 8,
          },
        });
      }
    }
  }, [sourceId, canFetch, selectedProject]);

  useEffect(() => {
    if (canFetch) {
      PmeDashboardGetWithFilters({
        noReset: true,
        setLoading,
        widget: 'recommendations',
        filters: activeFilters || {},
        pagination: {
          page: page || 1,
          perPage: 8,
        },
      });
      if (!initLoaded) {
        setInitLoaded(true);
      }
    }
  }, [language, canFetch]);

  return <Frame
    title={`${t('Dashboard::Recommendations from')} ${organisationName ? `${organisationName}` : ''}`}
    filters={filters}
    borderedHeader={false}
    onInit={actions => setFrameActions(actions)}
    onFilterChange={(filters, outActions) => {
      if (canFetch) {
        if (Object.values(filters).length > 0) {
          outActions.setClearFiltersVisibility(true);
        } else {
          outActions.setClearFiltersVisibility(false);
        }
        PmeDashboardGetWithFilters({
          noReset: true,
          setLoading,
          widget: 'recommendations',
          filters,
          pagination: {
            page: 1,
            perPage: 8,
          },
        });
        setActiveFilters(filters);
        setPage(1);
      }
    }}
    onClearFilters={() => {
      if (canFetch) {
        frameActions.setClearFiltersVisibility(false);
        /*
        PmeDashboardGetWithFilters({
          widget: 'recommendations',
          pagination: {
            page: 1,
            perPage: 8,
          },
        });
        setPage(1);
        */
      }
    }}
  >
    <Style className={dataSource.length > 0 ? 'has-data' : 'no-data'}>
      <RecTable
        page={page}
        total={total}
        dataSource={dataSource}
        PmeDashboardGetWithFilters={PmeDashboardGetWithFilters}
        setLoading={setLoading}
        options={data ? data.options || emptyObj : emptyObj}
        setPage={setPage}
        filters={activeFilters}
        initialFetchIsDone={initialFetchIsDone}
        t={t}
        isOwnData={isOwnData}
        organisationName={organisationName}
        project={selectedProject}
        language={language}
        user={user}
      />
    </Style>
  </Frame>;
}

export default connect(((dashboard) => (dashboard)), actions)(Recommendations);
